import clsx from 'clsx';

import { IDrawerSummaryProps } from '../types';

const testId = 'of-drawer-summary';

const DrawerSummary = ({ className, children }: IDrawerSummaryProps) => {
  const classProps = clsx(
    'bg-surface-secondary border border-surface-border py-[6px] px-16 mt-16',
    className
  );

  return (
    <div className={classProps} data-testid={testId}>
      {children}
    </div>
  );
};

export default DrawerSummary;
